"use strict";

var _lodash = require("lodash");
var _underscore = require("underscore");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Utils
/**
 * This controller handle the current module CTAs
 */
var CallToActions = /*#__PURE__*/function () {
  CallToActions.$inject = ["$route", "$routeParams", "blueprintService"];
  /* @ngInject */
  function CallToActions($route, $routeParams, blueprintService) {
    _classCallCheck(this, CallToActions);
    this.$route = $route;
    this.$routeParams = $routeParams;
    this.blueprintService = blueprintService;
  }

  /**
   * Called whenever one-way bindings are updated.
   *
   * @param {Object} changes a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }
   */
  return _createClass(CallToActions, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this = this;
      if ((0, _underscore.isEmpty)(changes.controller.currentValue)) {
        return;
      }
      var ctrl = changes.controller.currentValue;
      var eventId = this.$routeParams.eventId;
      this.ctas = (0, _underscore.chain)((0, _lodash.get)(ctrl, 'routeOptions.callToActions') || []).map(function (cta) {
        var createItemFpType = cta.createItemFpType,
          controllerKey = cta.controllerKey,
          label = cta.label;
        var currentRouteDescriptor = (0, _lodash.get)(_this.$route, 'current.$$route') || {};
        var currentRouteBlueprintMetadata = currentRouteDescriptor.blueprintMetadata || {};
        var moduleKey = currentRouteBlueprintMetadata.moduleKey;

        // find generic controller managing this type

        var navItems = _this.blueprintService.getControllerHeadings(moduleKey);
        var navItem;

        // the recommended way
        if (controllerKey) {
          // find right crud controller
          navItem = navItems.find(function (item) {
            return item.ctrlKey === controllerKey;
          });
        }

        // backward compatible way
        if (!navItem && createItemFpType) {
          // find right crud controller
          navItem = navItems.find(function (item) {
            return item.controller === 'GenericNewItemCtrl' && (0, _lodash.get)(item, 'routeOptions.modelFpType') === createItemFpType;
          });
        }

        // find a "create" controller
        if (!navItem) {
          navItem = navItems.find(function (item) {
            return item.ctrlKey === 'create';
          });
        }
        if (navItem && navItem.route && label) {
          return {
            link: navItem.route.replace(':eventId', eventId),
            label: label
          };
        } else {
          console.error('Defined an invalid call to action: ', cta);
        }
      }).compact().value();
    }
  }]);
}();
module.exports = angular.module('backstage.components.common.call-to-actions', []).component('bsCallToActions', {
  templateUrl: '/src/angular/components/common/call-to-actions/call-to-actions.html',
  bindings: {
    controller: '<'
  },
  controller: CallToActions
}).name;